import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
//import hello from 'hellojs'
import { NotificationContainer, NotificationManager } from 'react-notifications';

import { Auth } from '~/services'
import { addNetworkToUser } from '~/actions/sessions'


export default class extends React.Component {
    static propTypes = {
		connected_facebook: PropTypes.bool,
		connected_linkedin: PropTypes.bool,
		dispatch: PropTypes.func.isRequired
	};

    connectService = (client) => {
        /*
		if( !client || this.props['connected_'+client] ) return false;

		hello.init(Auth.hello.credentials);
		var options = Auth.hello[client];

		hello(client)
			.login(options)
				.then(this.connectSuccess, this.showError)
        */
	};

    connectSuccess = (data) => {
		this.props.dispatch( addNetworkToUser(data.network, data.authResponse) )
	};

    showError = (data) => {
		NotificationManager.error(data.error.message, '', 5000);
	};

    render() {

		return (

			<div>

				<div className="row mbot10">
					<div className="col-xs-4">
						<p>Facebook</p>
					</div>
					<div className="col-xs-8">
						{( !!this.props.connected_facebook 
							? <p className="text-mid-success"><i className="icon-check"></i> Connected</p>
							: <p className="clickable text-mid-main" onClick={this.connectService.bind(this, 'facebook')}><i className="icon-link"></i> Connect</p>
						)}
					</div>
				</div>

				<div className="row mbot10">
					<div className="col-xs-4">
						<p>Linkedin</p>
					</div>
					<div className="col-xs-8">
						{( !!this.props.connected_linkedin 
							? <p className="text-mid-success"><i className="icon-check"></i> Connected</p>
							: <p className="clickable text-mid-main" onClick={this.connectService.bind(this, 'linkedin')}><i className="icon-link"></i> Connect</p>
						)}
					</div>
				</div>
				
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Settings/components/AddOtherNetwork.jsx